module.exports = __webpack_public_path__ + "img/Partners8.b63ad250.png";